import { produce } from 'immer'
import createReducer from "./reducerUtils"
import { cloneDeep } from 'lodash'
import alerts from 'keys/alerts'
import toast from 'keys/toast'
import loading from 'keys/loading'
import dataGridModel from 'keys/dataGridModel';
import api from 'keys/apis'

const initialState = {
    menuIndex: 0,
    updateRoleIsPending: false,
    brokenDisplay: false,
    schoolYear: 2026,
    snackbars: {
        auth: {
            open: false,
            text: null,
            type: 'auth'
        },
        [toast.createTestTaker]: {
            open: false,
            text: "התלמיד נוצר בהצלחה",
            type: toast.createTestTaker
        },
        [toast.createAffiliation]: {
            open: false,
            text: "היחידה נוצר בהצלחה",
            type: toast.createAffiliation
        },
        [toast.createAssessment]: {
            open: false,
            text: "נשמר בהצלחה",
            type: toast.createAssessment
        }
    },
    hideRecord: false,
    alerts: {
        [alerts.createAffliation]: {
            open: false,
            close: { key: alerts.createAffliation, value: { open: false } }
        },
        [alerts.performAssessmentAgain]: {
            open: false,
            props: {}
        },
        [alerts.addSchoolClass]: {
            open: false,
            props: {}
        },
        [alerts.schoolSetup]: {
            open: false,
            props: {}
        },
        [alerts.versionMessage]: {
            open: false,
            props: {}
        },
        [alerts.exitEditAffiliation]: {
            open: false,
            props: {}
        },
        [alerts.selectStatusType]: {
            open: false,
            props: {}
        },
        [alerts.stuckReason]: {
            open: false,
            props: {}
        },
        [alerts.downloadStudentFile]: {
            open: false,
            props: {}
        },
        [alerts.createTestTaker]: {
            open: false,
            close: { key: alerts.createTestTaker, value: { open: false } }
        },
        [alerts.createTestTakers]: {
            open: false,
        },
        [alerts.performAssessment]: {
            open: false,
        },
        [alerts.contactUs]: {
            open: false,
        },
        [alerts.uploadAudio]: {
            open: false,
        },
        [alerts.preview]: {
            open: false,
        },
        [alerts.removeAssessment]: {
            open: false,
        },
        [alerts.deleteAssessments]: {
            open: false,
        },
        [alerts.removeTicket]: {
            open: false,
        },
        [alerts.removeTicketMessage]: {
            open: false,
        },
        [alerts.exitScreen]: {
            open: false,
        },
        [alerts.exitNormalator]: {
            open: false,
        },
        [alerts.backTo]: {
            open: false,
            props: null,
            close: { key: alerts.backTo, value: { open: false } }
        },
        [alerts.initializeAssessment]: {
            open: false,
            props: null,
            close: { key: alerts.initializeAssessment, value: { open: false } }
        },
        [alerts.createGrade]: {
            open: false,
            props: null,
            close: { key: alerts.createGrade, value: { open: false } }
        },
        [alerts.addLearningGroup]: {
            open: false,
            props: null,
            close: { key: alerts.addLearningGroup, value: { open: false } }
        },
        [alerts.createCoupon]: {
            open: false,
            props: null,
        },
        [alerts.micErrors]: {
            open: false,
            props: null,
        },
        [alerts.createClass]: {
            open: false,
            props: null,
            close: { key: alerts.createClass, value: { open: false } }
        },
        [alerts.createClass2]: {
            open: false,
            props: null,
            close: { key: alerts.createClass2, value: { open: false } }
        },
        [alerts.createShortClass]: {
            open: false,
            props: null,
            close: { key: alerts.createShortClass, value: { open: false } }
        },
        [alerts.newChild]: {
            open: false,
            props: null,
            close: { key: alerts.newChild, value: { open: false } }
        },
        [alerts.recordInstructions]: {
            open: false
        },
        [alerts.noBalance]: {
            open: false
        },
        [alerts.finishPerformAseessment]: {
            open: false
        },
        [alerts.normalatorConfirmation]: {
            open: false
        }
    },
    loading: {
        [loading.markingWords]: false,
        [loading.updateAsssessmentStatus]: false,
        [loading.createAssessmentWithFile]: false,
        [loading.printAssessment]: false
    },
    controllers: {
        [api.report]: () => { },
        [api.get_with_last_assessment]: () => { },
        [api.test_taker]: () => { },
        [api.assessments]: () => { },
        [api.get_audio_file]: () => { },
    }
}

const config = {
    updateController(state, action) {
        state.controllers = { ...state.controllers, ...action.payload }
    },
    setUpdateRoleIsPending(state, action) {
        state.updateRoleIsPending = action.payload
    },
    setBrokenDisplay(state, action) {
        state.brokenDisplay = action.payload
    },
    cleanController(state, action) {
        const controllers = action.payload
        let nControllers = {}
        controllers.map((controler) =>
            nControllers[controler] = new AbortController()
        )
        state.controllers = { ...state.controllers, ...nControllers }
    },
    setMenuIndex(state, action) {
        state.menuIndex = action.payload
    },
    setSnackbars(state, action) {
        const { type = "auth", open } = action.payload
        let nSnackbars = cloneDeep(state.snackbars)
        nSnackbars[type] = { ...action.payload }
        state.snackbars = nSnackbars
    },
    setColumnItems(state, action) {
        const { key, value } = action.payload
        let nColumnItems = cloneDeep(state.columnItems)
        nColumnItems[key] = value
        state.columnItems = nColumnItems
    },
    setLoading(state, action) {
        const nLoading = {}
        Object.keys(action.payload).map((key) => {
            nLoading[key] = action.payload[key]
        })
        state.loading = { ...state.loading, ...nLoading }
    },
    setHideRecord(state, action) {
        state.hideRecord = action.payload
    },
    setAlerts(state, action) {
        const { key, value } = action.payload
        state.alerts[key] = { ...state.alerts[key], ...value }
    }
}

export default produce(
    (state, action) => createReducer(state, action, config),
    initialState
)

